<template>
  <div
    v-if="loading"
    id="loading"
  >
    <div class="box">
      <i class="icon-hourglass">
        <div class="sand">
          <div class="top" />
          <div class="bottom" />
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="35"
          height="61"
          viewBox="0 0 35 61"
        >
          <defs>
            <path
              id="prefix__a"
              d="M1.124 1.254v18.21h.029l-.029.029 11.52 12.11-11.52 12.139.029.03h-.029v18.179h34.56V43.772h-.029l.029-.03-11.52-12.14 11.52-12.11-.029-.028h.029V1.254H1.124zm5.76 16.693V7.325h23.04v10.622l-11.52 12.137-11.52-12.137zm0 27.312l11.52-12.14 11.52 12.14V55.88H6.884V45.259z"
            />
          </defs>
          <g
            fill="none"
            fill-rule="evenodd"
            transform="translate(-1 -1)"
          >
            <mask
              id="prefix__b"
              fill="#fff"
            >
              <use xlink:href="#prefix__a" />
            </mask>
            <path
              fill="#402050"
              d="M-172.833 265.049L2039.056 265.049 2039.056 -995.561 -172.833 -995.561z"
              mask="url(#prefix__b)"
            />
            <path
              fill="#402050"
              d="M-4.636 67.786L41.446 67.786 41.446 -4.582 -4.636 -4.582z"
              mask="url(#prefix__b)"
            />
          </g>
        </svg>
      </i>
      <h1>Attendi</h1>
      <p v-if="msg">
        {{ msg }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    // TODO per gestire la retrocompatibilità, quando tutti useranno il loading
    // utilizzando le funzioni con il $ref rimuovere questa props
    isNewLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingCounter: 0,
      loading: true,
      loadingMsg: null,
      msg: null,
    };
  },
  watch: {
    isNewLoading: {
      handler() {
        this.loading = !this.isNewLoading;
      },
      deep: false,
      immediate: true,
    },
  },
  methods: {
    showLoading(show) {
      if (show) {
        this.loadingCounter++;
      } else {
        this.loadingCounter--;
      }
      this.loading = this.loadingCounter > 0;
    },
    toggleLoadingWithMsg(msg, show) {
      if (show) {
        this.msg = msg;
      } else {
        this.msg = null;
      }
      this.showLoading(show);
    },
    forceCloseLoading() {
      this.loadingCounter = 0;
      this.loading = false;
    },
  },
};
</script>
